var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3l0yhe8fna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1255H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6pe4vdddzb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.497 0a6.504 6.504 0 0 1 6.497 6.497 6.504 6.504 0 0 1-6.497 6.497A6.504 6.504 0 0 1 0 6.497 6.504 6.504 0 0 1 6.497 0zm0 1.42A5.083 5.083 0 0 0 1.42 6.497c0 2.8 2.278 5.077 5.077 5.077 2.8 0 5.077-2.277 5.077-5.077S9.297 1.42 6.497 1.42z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ko4c6xp0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.55-.003a.55.55 0 0 1 .55.55v2.725l1.85 1.85.04.04a.55.55 0 1 1-.78.778L.91 4.638l-.645-.645L.16 3.89a.547.547 0 0 1-.159-.416L0 3.448v-2.9a.55.55 0 0 1 .55-.55z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3l0yhe8fna)",
    transform: "translate(-412 -733)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6pe4vdddzb)",
    transform: "translate(412 733.03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6B119",
    d: "M0 0h12.994v12.994H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ko4c6xp0c)",
    transform: "translate(417.959 736.26)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6B119",
    d: "M-.001-.003H3.15v6.104H0V-.003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmall);
export default __webpack_public_path__ + "static/media/clock-small.896aeb4c866605e538407756e971c185.svg";
export { ForwardRef as ReactComponent };